import React from "react";
import styles from "./InfoTooltip.module.scss";

// Icône d'aide accessible : bulle révélée au survol ET au focus clavier.
// Le texte est annoncé aux lecteurs d'écran via aria-label ; la bulle est
// purement visuelle (aria-hidden).
const InfoTooltip = ({ text }) => (
  <span className={styles.wrap} tabIndex={0} aria-label={text}>
    <i className={`fa fa-info-circle ${styles.icon}`} aria-hidden="true" />
    <span className={styles.bubble} aria-hidden="true">
      {text}
    </span>
  </span>
);

export default InfoTooltip;
